import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsBecomeProducerPage } from 'types/cms/single-types'

/**
 * Get the become producer page from the CMS
 *
 * @param {Language} locale
 * @returns {Promise<CmsBecomeProducerPage | undefined>}
 */
const getBecomeProducerPage = async (locale: Language = Language.DUTCH): Promise<CmsBecomeProducerPage | undefined> => {
  try {
    const {
      data: { data }
    } = await axios.get<CMSApiResponseBody<CmsBecomeProducerPage>>(`${process.env.CMS_API_URL}/become-producer?locale=${locale}`)

    return data
  } catch (_) {
    return undefined
  }
}

export default getBecomeProducerPage
